import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  {
    name: "resident_id",
    label: "Resident",
    required: true,
    showInTable: true,
    lookup: {
      table: "residents",
      labelField: "full_name",
      secondaryField: "resident_code",
    },
  },
  { name: "name", label: "Name", required: true, showInTable: true },
  { name: "relation", label: "Relation", showInTable: true },
  { name: "mobile", label: "Mobile", type: "tel", showInTable: true },
  { name: "alt_mobile", label: "Alt Mobile", type: "tel" },
  { name: "email", label: "Email", type: "email" },
  { name: "date_of_birth", label: "Date of Birth", type: "date" },
  { name: "occupation", label: "Occupation" },
  { name: "address", label: "Address", type: "textarea" },
  { name: "city", label: "City" },
  { name: "state", label: "State" },
  { name: "is_primary", label: "Is Primary (true/false)" },
  { name: "is_emergency", label: "Is Emergency (true/false)" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export default function Page() {
  return (
    <AdminShell title="Resident Family" subtitle="Family contacts of residents">
      <ResourceTable
        table="resident_family"
        title="Family Contact"
        fields={fields}
        searchFields={["name", "mobile", "relation"]}
      />
    </AdminShell>
  );
}
